import { createPortal } from "react-dom";
import GlassLightbox from "./GlassLightbox";

interface IPortalGlassLightboxProps {
  src: string;
  alt?: string;
  onClose: () => void;
}

/**
 * {@link GlassLightbox} rendered at {@code document.body}, the DOM placement the react-modal it replaced had.
 *
 * <p>GlassLightbox's root is {@code position: fixed; inset: 0}, which only covers the viewport while no DOM
 * ancestor creates a containing block. Activity media sit inside option cards that do — {@code .mc-option:hover}
 * (transform), {@code .mc-correct}/{@code .mc-incorrect} and {@code .aas-bank} (backdrop-filter) — so an inline
 * lightbox filled the card instead of the screen; inside an ORDERING row ({@code draggable}) a drag-to-pan also
 * started a native row drag. Portalling removes every DOM ancestor while React events still bubble through the
 * React tree, exactly as with react-modal. A wrapper only: it adds no look, and GlassLightbox stays unchanged
 * (it is kept identical with admin-web).
 */
const PortalGlassLightbox = (props: IPortalGlassLightboxProps) =>
  typeof document === "undefined" ? null : createPortal(<GlassLightbox {...props} />, document.body);

export default PortalGlassLightbox;
